// src/pages/TermsOfServicePage.tsx

import { LegalPageLayout } from "../components/common/LegalPageLayout";
import { APP_CONFIG } from '../config/constants';

export default function TermsOfServicePage() {
    const lastUpdated = "11 de Outubro de 2025";
    // Gera um e-mail de suporte padrão a partir do nome da loja (sanitizado)
    const supportEmail = `suporte@${APP_CONFIG.storeName
        .normalize('NFD') // remove acentos
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '')}.com.br`;

    return (
        <LegalPageLayout title="Termos de Serviço">
            <p className="font-semibold">Última atualização: {lastUpdated}</p>
            <p>
                Bem-vindo à {APP_CONFIG.storeName}! Estes Termos de Serviço ("Termos") governam o seu uso do nosso site e dos serviços oferecidos. Ao acessar ou usar nosso serviço, você concorda em cumprir estes Termos.
            </p>

            <h2 className="text-2xl font-bold text-text-primary pt-4">1. Contas de Usuário</h2>
            <p>
                Para acessar certas funcionalidades, você pode precisar criar uma conta. Você é responsável por manter a confidencialidade de sua senha e por todas as atividades que ocorram em sua conta. Você concorda em nos notificar imediatamente sobre qualquer uso não autorizado de sua conta.
            </p>

            <h2 className="text-2xl font-bold text-text-primary pt-4">2. Compra e Uso de Plugins</h2>
            <p>
                Ao comprar um plugin em nossa loja, você adquire uma licença para usar o plugin em conformidade com os termos específicos de cada produto. A redistribuição ou revenda não autorizada dos plugins é estritamente proibida.
            </p>
            <p>
                Todos os pagamentos são processados através de gateways de pagamento seguros. Não armazenamos informações de cartão de crédito.
            </p>

            <h2 className="text-2xl font-bold text-text-primary pt-4">3. Propriedade Intelectual</h2>
            <p>
                Todos os plugins, textos, gráficos e logotipos em nosso site são propriedade da {APP_CONFIG.storeName} ou de seus respectivos desenvolvedores e são protegidos por leis de direitos autorais.
            </p>

            <h2 className="text-2xl font-bold text-text-primary pt-4">4. Limitação de Responsabilidade</h2>
            <p>
                A {APP_CONFIG.storeName} não se responsabiliza por quaisquer danos diretos ou indiretos que possam ocorrer em seu servidor ou negócio devido ao uso (ou mau uso) de nossos plugins. Oferecemos os produtos "como estão", sem garantias de qualquer tipo.
            </p>

            <h2 className="text-2xl font-bold text-text-primary pt-4">5. Alterações nos Termos</h2>
            <p>
                Reservamo-nos o direito de modificar estes Termos a qualquer momento. Notificaremos sobre alterações significativas, e o uso contínuo do serviço após tais alterações constituirá sua aceitação dos novos Termos.
            </p>

            <h2 className="text-2xl font-bold text-text-primary pt-4">6. Contato</h2>
            <p>
                Se você tiver alguma dúvida sobre estes Termos, entre em contato conosco pelo e-mail: <a href={`mailto:${supportEmail}`} className="text-brand-blue hover:underline">{supportEmail}</a>.
            </p>
        </LegalPageLayout>
    );
}